<script setup lang="ts">
// const route = useRoute();
// const currentPath = computed(() => route.fullPath);
const currentYear = computed(() => new Date().getFullYear());
</script>

<template>
	<footer>
		<div class="partenaires">
			<div class="container">
				<h3>Nos partenariats</h3>
				<div class="partenaires-items">
					<a href="https://script.lu/fr"
						target="_blank"
						rel="noreferrer noopener">
						<figure>
							<img src="/img/footer/part_script.png"
								alt="Logo partenaire Script"
								style="object-fit:cover;width:220px;height:78px" />
						</figure>
					</a>
					<a href="https://www.reseau-canope.fr/"
						target="_blank"
						rel="noreferrer noopener">
						<figure>
							<img src="/img/footer/part_canope.png"
								alt="Logo partenaire Canopé"
								style="object-fit:cover;width:151px;height:54px" />
						</figure>
					</a>
					<a href="https://www.snj.public.lu/"
						target="_blank"
						rel="noreferrer noopener">
						<figure>
							<img src="/img/footer/part_snj.png"
								alt="Logo partenaire SNJ"
								style="object-fit:cover;width:188px;height:45px" />
						</figure>
					</a>
					<a href="https://www.granderegion.net/"
						target="_blank"
						rel="noreferrer noopener">
						<figure>
							<img src="/img/footer/part_grande_region.png"
								alt="Logo partenaire Grande Région"
								style="object-fit:cover;width:160px;height:68px" />
						</figure>
					</a>
					<a href="https://script.lu/fr"
						target="_blank"
						rel="noreferrer noopener">
						<figure>
							<img src="/img/footer/part_junior_uni.png"
								alt="Logo partenaire Junior Uni"
								style="object-fit:cover;width:186px;height:68px" />
						</figure>
					</a>
					<a href="http://www.eun.org/"
						target="_blank"
						rel="noreferrer noopener">
						<figure>
							<img src="/img/footer/part_eun.png"
								alt="Logo partenaire eun"
								style="object-fit:cover;width:138px;height:66px" />
						</figure>
					</a>
				</div>
			</div>
		</div>
		<div class="footer">
			<div class="container">
				<div class="row wp-block-columns">
					<div class="col-md-3 col-footer wp-block-column">
						<figure>
							<img src="/img/footer/logo_ifen_footer.svg"
								width="68"
								height="54"
								alt="Logo Ifen footer" />
						</figure>
						<p><strong>Tél. :</strong> <a href="tel:+35224775100">(+352) 247-75100</a></p>
						<p><strong>Email :</strong> <a href="mailto:info@ifen.lu">info@ifen.lu</a></p>
						<div class="footer-social">
							<a href="hhttps://www.facebook.com/InstitutFormationEducationNationale"
								target="_blank"
								rel="noreferrer noopener">
								<figure>
									<img src="/img/footer/picto_facebook_footer.svg"
										width="37"
										height="37"
										alt="Logo Facebook" />
								</figure>
							</a>
							<a href="https://www.linkedin.com/company/institut-de-formation-de-l-education-nationale-ifen/"
								target="_blank"
								rel="noreferrer noopener">
								<figure>
									<img src="/img/footer/picto_linkedin_footer.svg"
										width="37"
										height="37"
										alt="Logo LinkedIn" />
								</figure>
							</a>
						</div>
					</div>
					<div class="col-md-3 col-footer wp-block-column">
						<h3>Liens</h3>
						<ul>
							<li>
								<a href="https://portal.education.lu/cgie/EXPERIENCES/ArticleID/182/eduroam"
									target="_blank"
									rel="noreferrer noopener">eduroam</a>
							</li>
							<li>
								<a href="https://learningsphere.ifen.lu/"
									target="_blank"
									rel="noreferrer noopener">LearningSphere</a>
							</li>
							<li>
								<a href="https://ssl.education.lu/edvance2/"
									target="_blank"
									rel="noreferrer noopener">edvance</a>
							</li>
						</ul>
						<h3 style="margin-top: 20px;">
							<a href="/ifen/faq/">FAQ</a>
						</h3>
					</div>
					<div class="col-md-3 col-footer wp-block-column">
						<h3>Où nous trouver ?</h3>
						<p><strong>Site edupôle</strong><br />route de Diekirch,<br />L-7220 Walferdange</p>
						<p><strong>Site Terres-Rouges</strong><br />3 et 5 rue de la fonte,<br />L-4364 Esch-sur-Alzette</p>
					</div>
					<div class="col-md-3 col-footer wp-block-column">
						<h3>Contact <span style="text-decoration: underline;">réservé</span> à la presse</h3>
						<p>Élise Le Bréquier</p>
						<p><strong>Tél. :</strong> <a href="tel:+35224775150">(+352) 247-75150</a></p>
						<p><strong>Email :</strong> <a href="mailto:communication@ifen.lu">communication@ifen.lu</a></p>
					</div>
				</div>
				<div class="row row-2">
					<div class="col-lg-6">
						<p>© {{ currentYear }} Institut de formation de l’Éducation nationale</p>
					</div>
					<div class="col-lg-6">
						<ul class="wp-block-list">
							<li>
								<a href="/ifen/notice-legale/">Notice légale</a>
							</li>
							<li>
								<a :href="`#rgpd`">Gestion des cookies</a>
							</li>
							<li>
								<a href="/ifen/plan-du-site/">Plan du site</a>
							</li>
							<li>
								<a href="/ifen/a-propos-du-site/">À propos du site</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>
